import { render, staticRenderFns } from "./systemUserDetailList.vue?vue&type=template&id=1c2d309e&scoped=true"
import script from "./systemUserDetailList.vue?vue&type=script&lang=js"
export * from "./systemUserDetailList.vue?vue&type=script&lang=js"
import style0 from "./systemUserDetailList.vue?vue&type=style&index=0&id=1c2d309e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2d309e",
  null
  
)

export default component.exports